import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Hoe lang duurt de overstap?",
    a: "Dat hangt af van het aantal werkplekken en hoeveel data er verhuisd moet worden. Voor de meeste bedrijven is de voorbereiding binnen één tot twee weken klaar. De overstapdag zelf? Die is meestal in een paar uur gepiept.",
  },
  {
    q: "Kan ik gewoon doorwerken tijdens de migratie?",
    a: "Ja! Het grootste deel van de migratie doen we op de achtergrond. Op de dag van de overstap wisselen we computers door, zodat je team nauwelijks iets merkt. Inloggen en verder werken.",
  },
  {
    q: "Raken we data kwijt bij de overstap?",
    a: "Nee. We verhuizen alles zorgvuldig: e-mails, agenda's, contacten en bestanden. En we controleren alles dubbel. Vanaf dag één draaien er ook meteen back-ups mee.",
  },
  {
    q: "We werken nu met Google Workspace. Kan dat ook?",
    a: "Absoluut. We migreren regelmatig van Google Workspace naar Microsoft 365. Alle data wordt op de achtergrond overgezet — jullie kunnen intussen gewoon doorwerken.",
  },
  {
    q: "We hebben al Microsoft 365. Wat verandert er dan?",
    a: "We nemen het beheer over en brengen je omgeving naar de laatste standaarden op het gebied van veiligheid en configuratie. Met speciale software houden we alles daarna ook continu up-to-date. Jij merkt er weinig van, behalve dat het beter wordt.",
  },
  {
    q: "Wat kost de implementatie?",
    a: "De eenmalige implementatiekosten bedragen € 225,00 per werkplek. Komt er later een nieuwe medewerker bij? Dan betaal je geen implementatiekosten — er hoeft dan namelijk geen data verhuisd te worden.",
  },
  {
    q: "Moeten we nieuwe computers kopen?",
    a: "Niet per se! Tijdens de overstap installeren we je bestaande computers helemaal opnieuw. Ze voelen daarna weer als nieuw en gaan er zo weer jaren mee. Beter voor het milieu én je portemonnee.",
  },
  {
    q: "Wat gebeurt er met onze domeinnaam?",
    a: "Jij blijft altijd eigenaar van je domein. Wij nemen bij voorkeur het DNS-beheer over, zodat we snel kunnen schakelen bij wijzigingen. Zie het als het telefoonboek van het internet — wij zorgen dat alles naar de juiste plek verwijst.",
  },
  {
    q: "Wie is ons aanspreekpunt na de overstap?",
    a: "Wij! Vanaf het moment dat we het beheer overnemen, zijn wij je vaste aanspreekpunt. Geen ticketsystemen of wachtrijen — gewoon bellen en direct iemand aan de lijn.",
  },
];

const MigrationFAQ = () => {
  return (
    <section className="py-16 md:py-24">
      <div className="container">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-2xl font-bold md:text-3xl">
            Veelgestelde{" "}
            <span className="text-gradient">vragen</span>
          </h2>
          <p className="mt-3 text-lg text-muted-foreground">
            Alles wat je wilt weten over de overstap — zonder kleine lettertjes.
          </p>
        </motion.div>

        <motion.div
          className="mx-auto max-w-3xl"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="rounded-xl border border-border bg-card px-6 shadow-card"
              >
                <AccordionTrigger className="text-left font-semibold text-sm md:text-base hover:no-underline">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-muted-foreground">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default MigrationFAQ;
